export const multiSelectFieldStyle = {
  control: (base, state) => ({
    ...base,
    minHeight: "3em",
    borderRadius: "0.75em",
    boxShadow:
      "0.8px 1.6px 3.2px 0px rgba(0, 0, 0, 0.02),2.4px 4.8px 6.4px 0px rgba(0, 0, 0, 0.02),5.6px 11.2px 8px 0px rgba(0, 0, 0, 0.01)",
    backgroundColor: "#fcfafc",
    borderColor: state.isFocused ? "#107ff2" : "transparent",
    "&:hover": {
      border: "1px solid #107ff2",
    },
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "15em",
    "::-webkit-scrollbar": {
      width: ".3em",
      height: ".3em",
    },
    "::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "::-webkit-scrollbar-thumb": {
      background: "#b7b5ba",
      borderRadius: "100px",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "#107ff2",
    },
  }),
  menu: (base) => ({
    ...base,
    zIndex: 5,
    borderRadius: ".75em",
    overflow: "hidden",
    padding: ".75em",
  }),
  option: (base, state) => ({
    ...base,
    borderRadius: "0.5em",
    marginBottom: ".25em",
    marginTop: ".25em",
    backgroundColor: state.isSelected ? "#107ff2" : "transparent",
    color: state.isSelected ? "#fcfcfc" : "#6b6970",
    "&:hover": {
      color: "#222024",
      backgroundColor: "#107ff23a", //"rgb(106, 24, 237, 0.3)",
    },
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    transition: "all .3s",
    color: state.isFocused ? "#107ff2" : "#6b6970",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
  }),
  multiValue: (styles) => {
    return {
      ...styles,
      backgroundColor: "#107ff23a", //"rgb(106, 24, 237, 0.3)",
    };
  },
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: data.color,
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: data.color,
    ":hover": {
      backgroundColor: "#107ff2",
      color: "#fcfcfc",
    },
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      opacity: "0.5",
    };
  },
};
